import { RootStore } from '@uplift/store';
import { environment } from '../environments/environment';


export const rootStore = RootStore.createRootStore(environment);
